// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"partner-footer_wrapper__oEZZC"};